// extracted by mini-css-extract-plugin
module.exports = {"regionBtnBack":"ReturnHistory_regionBtnBack__3ykAu"};